import '../css/default.css';
import '../css/hills.css';

import { getItem, setItem } from '../Storage';

const get_class = (class_name) => {
  let partner        = getItem('partner');
  let partner_name   = partner && partner.name ? partner.name : '';
  let prefix_string  = partner_name;
  let combined_class = class_name;

  switch (partner_name) {
    case 'teletails':
      combined_class = 'teletails-' +  class_name;
      break;
    case 'hills':
      combined_class = 'hills-' +  class_name;
      break;
    case 'amazon':
      combined_class = 'amazon-' +  class_name;
      break;
    case 'drmarty':
      combined_class = 'drmarty-' +  class_name;
      break;
    case 'snugglepuppy':
      combined_class = 'snugglepuppy-' +  class_name;
      break;
    case 'darwins':
      combined_class = 'darwins-' +  class_name;
      break;
    case 'getjoy':
      combined_class = 'getjoy-' +  class_name;
      break;
    case 'wag':
      combined_class = 'wag-' +  class_name;
      break;
    case 'wagmo':
      combined_class = 'wagmo-' +  class_name;
      break;
    case 'ussa':
      combined_class = 'ussa-' +  class_name;
      break;
    case 'dogac':
      combined_class = 'hills-' +  class_name;
      break;
    case 'geniustag':
      combined_class = 'geniustag-' +  class_name;
      break;
    case 'conciergevet':
      combined_class = 'conciergevet-' +  class_name;
      break;
    case 'fable':
      combined_class = 'fable-' +  class_name;
      break;
    case 'zestypaws':
      combined_class = 'zestypaws-' +  class_name;
      break;
    case 'pupford':
      combined_class = 'pupford-' +  class_name;
      break;
    case 'upc':
      combined_class = 'upc-' +  class_name;
      break;
    case 'embark':
      combined_class = 'embark-' +  class_name;
      break;
    default:

  }

  return combined_class;
}

const get_color = () => {
  let partner        = getItem('partner');
  let partner_name   = partner && partner.name ? partner.name : '';
  let color_hex      = '#1dc2ff';

  switch (partner_name) {
    case 'teletails':
      color_hex = '#1dc2ff';
      break;
    case 'amazon':
      color_hex = '#FF9900';
      break;
    case 'hills':
      color_hex = '#0054A8';
      break;
    case 'drmarty':
      color_hex = '#18A574';
      break;
    case 'snugglepuppy':
      color_hex = '#00A2D5';
      break;
    case 'darwins':
      color_hex = '#00214A';
      break;
    case 'getjoy':
      color_hex = '#77cc35';
      break;
    case 'wag':
      color_hex = '#00BF8F';
      break;
    case 'wagmo':
      color_hex = '#17493D';
      break;
    case 'ussa':
      color_hex = '#d32110';
      break;
    case 'dogac':
      color_hex = '#0054A8';
      break;
    case 'geniustag':
      color_hex = '#F82D3F';
      break;
    case 'conciergevet':
      color_hex = '#EFB256';
      break;
    case 'fable':
      color_hex = '#738DE8';
      break;
    case 'zestypaws':
      color_hex = '#ec7700';
      break;
    case 'pupford':
      color_hex = '#e64b38';
      break;
    case 'upc':
      color_hex = '#3b6cf6';
      break;
    case 'embark':
      color_hex = '#ffce34';
      break;
    default:

  }

  return color_hex;
}

const get_button_color = () => {
  let partner = getItem('partner');
  let style_customizations = partner && partner.style_customizations ? partner.style_customizations : {};
  let button_color = style_customizations.button_color_hex ? style_customizations.button_color_hex : '#1dc2ff';
  return button_color;
}

const get_button_text_color = () => {
  let partner = getItem('partner');
  let style_customizations = partner && partner.style_customizations ? partner.style_customizations : {};
  let button_text_color = style_customizations.button_text_color_hex ? style_customizations.button_text_color_hex : '#ffffff';
  return button_text_color;
}

const get_header_color = () => {
  let partner = getItem('partner');
  let style_customizations = partner && partner.style_customizations ? partner.style_customizations : {};
  let header_color = style_customizations.header_color_hex ? style_customizations.header_color_hex : '#1dc2ff';
  return header_color;
}

const get_header_text_color = () => {
  let partner = getItem('partner');
  let style_customizations = partner && partner.style_customizations ? partner.style_customizations : {};
  let header_text_color = style_customizations.header_text_color_hex ? style_customizations.header_text_color_hex : '#000000';
  return header_text_color;
}

const get_primary_color = () => {
  let partner = getItem('partner');
  let style_customizations = partner && partner.style_customizations ? partner.style_customizations : {};
  let primary_color = style_customizations.primary_color_hex ? style_customizations.primary_color_hex : '#1dc2ff';
  return primary_color;
}

const hex_to_rgb = (hex) => {
  if (!hex || typeof hex !== 'string') { return null; }
  let clean = hex.replace('#', '');
  if (clean.length === 3) {
    clean = clean.split('').map((c) => c + c).join('');
  }
  if (clean.length !== 6) { return null; }
  let r = parseInt(clean.substring(0, 2), 16);
  let g = parseInt(clean.substring(2, 4), 16);
  let b = parseInt(clean.substring(4, 6), 16);
  if (isNaN(r) || isNaN(g) || isNaN(b)) { return null; }
  return { r, g, b };
}

// Blend hex_a into hex_b; weight is hex_a's share (0-1).
const mix_hex = (hex_a, hex_b, weight) => {
  let a = hex_to_rgb(hex_a);
  let b = hex_to_rgb(hex_b);
  if (!a || !b) { return hex_a; }
  let channel = (ca, cb) => Math.round(ca * weight + cb * (1 - weight)).toString(16).padStart(2, '0');
  return '#' + channel(a.r, b.r) + channel(a.g, b.g) + channel(a.b, b.b);
}

const get_yiq = (hex) => {
  let rgb = hex_to_rgb(hex);
  if (!rgb) { return 255; }
  return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
}

// Partner display switches set on the admin's Color Theme card.
const is_header_gradient_disabled = () => {
  let partner = getItem('partner');
  let style_customizations = partner && partner.style_customizations ? partner.style_customizations : {};
  return style_customizations.disable_header_gradient === true;
}

const is_logo_bg_transparent = () => {
  let partner = getItem('partner');
  let style_customizations = partner && partner.style_customizations ? partner.style_customizations : {};
  return style_customizations.transparent_logo_bg === true;
}

// Hero band gradient stops, tuned to the brand color's lightness. Bright
// accents keep the classic bright-to-deep fade; dark accents would sink into
// near-black with that mix, so they instead get a gently lifted sheen that
// settles on the true brand color. With the gradient switched off both stops
// are the header color itself, so the band paints flat.
const get_header_gradient_start = () => {
  let color = get_header_color();
  if (is_header_gradient_disabled()) { return color; }
  return get_yiq(color) < 100 ? mix_hex(color, '#ffffff', 0.84) : color;
}

const get_header_gradient_end = () => {
  let color = get_header_color();
  if (is_header_gradient_disabled()) { return color; }
  return get_yiq(color) < 100 ? color : mix_hex(color, '#000000', 0.82);
}

// Class modifiers for a hero band and its logo chip, from the partner's display switches.
const get_hero_class = (base) => {
  return base + (is_header_gradient_disabled() ? ' is-flat' : '');
}

const get_logo_chip_class = (base) => {
  return base + (is_logo_bg_transparent() ? ' is-transparent' : '');
}

// Returns a legible text color (slate-900 or white) for a given background hex,
// using the YIQ luminance of the background.
const get_contrast_color = (hex) => {
  if (!hex || typeof hex !== 'string') { return '#0f172a'; }
  let clean = hex.replace('#', '');
  if (clean.length === 3) {
    clean = clean.split('').map((c) => c + c).join('');
  }
  if (clean.length !== 6) { return '#0f172a'; }
  let r = parseInt(clean.substring(0, 2), 16);
  let g = parseInt(clean.substring(2, 4), 16);
  let b = parseInt(clean.substring(4, 6), 16);
  if (isNaN(r) || isNaN(g) || isNaN(b)) { return '#0f172a'; }
  let yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 186 ? '#0f172a' : '#ffffff';
}

// Header text color: honor an explicit partner override, otherwise auto-pick a
// legible color from the header background so saturated/dark bands stay readable.
const get_header_text_color_auto = () => {
  let partner = getItem('partner');
  let style_customizations = partner && partner.style_customizations ? partner.style_customizations : {};
  if (style_customizations.header_text_color_hex) {
    return style_customizations.header_text_color_hex;
  }
  return get_contrast_color(get_header_color());
}

// Button text color: honor an explicit partner override, otherwise auto-pick a
// legible color from the button background (so light accents like yellow get dark text).
const get_button_text_color_auto = () => {
  let partner = getItem('partner');
  let style_customizations = partner && partner.style_customizations ? partner.style_customizations : {};
  if (style_customizations.button_text_color_hex) {
    return style_customizations.button_text_color_hex;
  }
  return get_contrast_color(get_button_color());
}

// Onboarding (IntroSlides / SignIn) tints, pre-mixed in JS so they work
// without color-mix(): image-panel fill, CTA glow, focus ring. The backdrop is
// the same neutral page ground the signed-in screens use (--sln-bg).
const get_intro_palette = () => {
  let primary  = get_primary_color();
  let button   = get_button_color();
      primary  = hex_to_rgb(primary) ? primary : '#1dc2ff';
  let backdrop = '#F5F7FB';
  let panel    = mix_hex(primary, '#ffffff', 0.13);
  let glow_rgb = hex_to_rgb(button) || { r: 29, g: 194, b: 255 };
  let ring_rgb = hex_to_rgb(primary) || { r: 29, g: 194, b: 255 };
  let btn_glow = `rgba(${ glow_rgb.r }, ${ glow_rgb.g }, ${ glow_rgb.b }, 0.55)`;
  let ring     = `rgba(${ ring_rgb.r }, ${ ring_rgb.g }, ${ ring_rgb.b }, 0.18)`;
  return { backdrop, panel, btn_glow, ring };
}

export default {
  get_class,
  get_color,
  get_button_color,
  get_button_text_color,
  get_button_text_color_auto,
  get_header_color,
  get_header_gradient_start,
  get_header_gradient_end,
  is_header_gradient_disabled,
  is_logo_bg_transparent,
  get_hero_class,
  get_logo_chip_class,
  get_header_text_color,
  get_header_text_color_auto,
  get_contrast_color,
  get_primary_color,
  get_intro_palette,
}
